module.exports = __webpack_public_path__ + "static/media/47.cf6839df.JPG";